import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import React from 'react';
class ToolErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, info) {
        console.error('[ToolErrorBoundary]', error, info.componentStack);
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs(Box, { sx: { p: 4 }, children: [_jsx(Typography, { variant: "h6", color: "error", gutterBottom: true, children: "Something went wrong in this tool" }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 3 }, children: this.state.error?.message }), _jsx(Button, { variant: "outlined", onClick: () => this.setState({ hasError: false, error: null }), children: "Try again" })] }));
        }
        return this.props.children;
    }
}
export default ToolErrorBoundary;
